<template>
  <footer class="blog-footer">
    <!-- 顶部装饰波浪 -->
    <div class="footer-wave" aria-hidden="true">
      <svg viewBox="0 0 1440 80" preserveAspectRatio="none">
        <path
          d="M0,40 C240,80 480,0 720,40 C960,80 1200,0 1440,40 L1440,80 L0,80 Z"
          fill="currentColor"
        />
      </svg>
    </div>

    <div class="container">
      <!-- 主体内容 -->
      <div class="footer-main">
        <!-- 品牌介绍 -->
        <div class="footer-brand">
          <a href="/" class="brand-logo">
            <span class="brand-icon">陌</span>
            <span class="brand-text">Blog</span>
          </a>
          <p class="brand-desc">
            专注于分享技术文章、开发经验和生活感悟的个人博客平台。
            用心记录，用文字与世界对话。
          </p>

          <!-- 数据小彩蛋 -->
          <div class="brand-stats">
            <div class="stat-item">
              <span class="stat-num">{{ runningDays }}</span>
              <span class="stat-label">天运行</span>
            </div>
            <div class="stat-divider" aria-hidden="true"></div>
            <div class="stat-item">
              <span class="stat-num">∞</span>
              <span class="stat-label">篇文章</span>
            </div>
            <div class="stat-divider" aria-hidden="true"></div>
            <div class="stat-item">
              <span class="stat-num">{{ currentYear }}</span>
              <span class="stat-label">版权年</span>
            </div>
          </div>

          <!-- 社交链接 -->
          <div class="social-list">
            <a href="#" class="social-link social-github" title="GitHub" aria-label="GitHub">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 0C5.373 0 0 5.373 0 12c0 5.303 3.438 9.8 8.205 11.385.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576C20.566 21.797 24 17.3 24 12c0-6.627-5.373-12-12-12z" fill="currentColor"/>
              </svg>
            </a>
            <a href="#" class="social-link social-juejin" title="掘金" aria-label="掘金">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 14.316l7.454-5.88-2.022-1.625L12 11.1l-5.432-4.288-2.022 1.625 7.454 5.88zm0-10.316l2.05 1.616L12 7.252 9.95 5.616 12 4zM1.78 8.64l1.526 1.223L12 16.752l8.694-6.889 1.526-1.223L12 20.752 1.78 8.64z" fill="currentColor"/>
              </svg>
            </a>
            <a href="#" class="social-link social-weibo" title="微博" aria-label="微博">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M10.098 20c-3.556.5-6.638-1.209-6.861-3.82-.222-2.609 2.479-5.027 6.036-5.527 3.556-.5 6.638 1.209 6.861 3.82.222 2.609-2.479 5.027-6.036 5.527zm7.46-9.15c-.318-.104-.537-.166-.367-.58.367-.91.41-1.699.012-2.277-.752-1.09-2.797-1.034-5.129-.022 0 0-.738.328-.55-.262.369-1.177.31-2.164-.257-2.722-1.272-1.248-4.663.039-7.571 2.88C1.22 10.445 0 12.849 0 14.9c0 3.865 4.984 6.171 9.915 6.171 6.479 0 10.789-3.653 10.789-6.545 0-1.747-1.475-2.738-3.146-3.676zM18.952 8.32c-.923-1.022-2.293-1.426-3.652-1.182a.633.633 0 0 0-.477.753.634.634 0 0 0 .753.478c.972-.176 1.955.119 2.617.854.662.736.833 1.72.527 2.608a.748.748 0 0 0 .455.958.754.754 0 0 0 .961-.459c.418-1.203.183-2.555-.684-3.502-.05-.06-.1-.12-.149-.175l.59.666zm2.235-2.116c-1.78-1.97-4.42-2.747-7.038-2.272a.835.835 0 0 0-.632 1.003c.135.553.727.895 1.278.762 2.072-.375 4.183.244 5.603 1.816 1.419 1.572 1.815 3.695 1.12 5.425a.836.836 0 0 0 .527 1.072.84.84 0 0 0 1.071-.529c.985-2.464.424-5.481-1.631-7.777-.031-.047-.065-.093-.1-.139l.798.632z" fill="currentColor"/>
              </svg>
            </a>
            <a href="#" class="social-link social-wechat" title="微信" aria-label="微信">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M8.691 2C4.768 2 1.5 4.657 1.5 7.945c0 1.9 1.166 3.585 2.99 4.714l-.746 2.244 2.615-1.308c.746.149 1.49.298 2.236.298.187 0 .372-.009.555-.023a5.31 5.31 0 0 1-.212-1.452c0-3.173 2.99-5.751 6.697-5.751.187 0 .372.009.555.023C15.673 3.873 12.45 2 8.691 2zM6.08 6.284c.374 0 .747.299.747.746a.745.745 0 0 1-.747.745.746.746 0 0 1-.747-.745c0-.447.373-.746.747-.746zm5.224 0c.373 0 .746.299.746.746a.745.745 0 0 1-.746.745.746.746 0 0 1-.747-.745c0-.447.373-.746.747-.746zm4.854 3.173c-3.148 0-5.603 2.05-5.603 4.587 0 2.538 2.455 4.588 5.603 4.588.632 0 1.264-.075 1.896-.225l1.958 1.125-.561-1.65c1.492-1.05 2.455-2.537 2.455-4.238 0-2.537-2.455-4.587-5.748-4.587zm-1.87 3.019c.28 0 .56.225.56.561a.564.564 0 0 1-.56.561.565.565 0 0 1-.561-.561c0-.336.28-.561.561-.561zm3.738 0c.28 0 .561.225.561.561a.565.565 0 0 1-.561.561.564.564 0 0 1-.56-.561c0-.336.28-.561.56-.561z" fill="currentColor"/>
              </svg>
            </a>
            <a href="#" class="social-link social-rss" title="RSS" aria-label="RSS">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M6.18 15.64a2.18 2.18 0 0 1 2.18 2.18C8.36 19 7.38 20 6.18 20C5 20 4 19 4 17.82a2.18 2.18 0 0 1 2.18-2.18M4 4.44A15.56 15.56 0 0 1 19.56 20h-2.83A12.73 12.73 0 0 0 4 7.27V4.44m0 5.66a9.9 9.9 0 0 1 9.9 9.9h-2.83A7.07 7.07 0 0 0 4 12.93V10.1z" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </div>

        <!-- 快速链接 -->
        <div class="footer-col">
          <h4 class="col-title">
            <span class="col-title-bar"></span>
            快速链接
          </h4>
          <ul class="col-list">
            <li><a href="/">首页</a></li>
            <li><a href="/about">关于我</a></li>
            <li><a href="/archives">文章归档</a></li>
            <li><a href="/tags">标签云</a></li>
            <li><a href="/messages">留言板</a></li>
          </ul>
        </div>

        <!-- 热门分类 -->
        <div class="footer-col">
          <h4 class="col-title">
            <span class="col-title-bar"></span>
            热门分类
          </h4>
          <ul class="col-list">
            <li><a href="/category/frontend">前端开发</a></li>
            <li><a href="/category/backend">后端技术</a></li>
            <li><a href="/category/design">设计美学</a></li>
            <li><a href="/category/lifestyle">生活随笔</a></li>
            <li><a href="/category/tools">工具分享</a></li>
          </ul>
        </div>

        <!-- 订阅 / 联系方式 -->
        <div class="footer-col footer-subscribe">
          <h4 class="col-title">
            <span class="col-title-bar"></span>
            订阅更新
          </h4>
          <p class="subscribe-desc">
            留下邮箱，第一时间收到新文章推送。我们承诺不发送垃圾邮件。
          </p>
          <form class="subscribe-form" @submit.prevent="handleSubscribe">
            <input
              type="email"
              v-model="subscribeEmail"
              class="subscribe-input"
              placeholder="your@email.com"
              aria-label="订阅邮箱"
              required
            />
            <button type="submit" class="subscribe-btn" :disabled="subscribed">
              <template v-if="!subscribed">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M2 2l20 10-20 10V2zm3 3v5.5l11 4.5-11 4.5V20" stroke="currentColor" stroke-width="2" fill="none" stroke-linejoin="round"/>
                </svg>
                <span>订阅</span>
              </template>
              <template v-else>
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                  <path d="M5 12l5 5L20 7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" fill="none"/>
                </svg>
                <span>已订阅</span>
              </template>
            </button>
          </form>
          <p class="subscribe-tip" v-if="subscribed">感谢订阅，期待和你一起成长 ✨</p>

          <div class="contact-mini">
            <div class="contact-item" title="邮箱">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" fill="currentColor"/>
              </svg>
              <span>contact@mogong.com</span>
            </div>
            <div class="contact-item" title="地点">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 0 1 0-5 2.5 2.5 0 0 1 0 5z" fill="currentColor"/>
              </svg>
              <span>Made with ❤ in China</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 分割线 -->
      <div class="footer-divider" aria-hidden="true">
        <span class="divider-dot"></span>
      </div>

      <!-- 底部版权 -->
      <div class="footer-bottom">
        <div class="copyright">
          <p>&copy; {{ currentYear }} 陌攻网站 · 保留所有权利</p>
          <p class="copyright-sub">
            Powered by <a href="#" class="text-link">Vue</a>
            &nbsp;·&nbsp;
            <a href="#" class="text-link">Java</a>
            &nbsp;·&nbsp;
            <span class="power-heart">❤</span>
          </p>
        </div>

        <nav class="footer-nav" aria-label="底部导航">
          <ul>
            <li><a href="/privacy">隐私政策</a></li>
            <li><a href="/terms">使用条款</a></li>
            <li><a href="/sitemap">网站地图</a></li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- 背景装饰光晕 -->
    <div class="footer-glow glow-left" aria-hidden="true"></div>
    <div class="footer-glow glow-right" aria-hidden="true"></div>
    <div class="footer-grid-bg" aria-hidden="true"></div>
  </footer>
</template>

<script>
export default {
  name: 'BlogFooter',
  data() {
    return {
      subscribeEmail: '',
      subscribed: false
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
    // 博客建站日起的运行天数（可自由调整起点日期）
    runningDays() {
      const start = new Date('2023-01-01')
      const now = new Date()
      const diff = Math.floor((now - start) / (1000 * 60 * 60 * 24))
      return diff > 0 ? diff : 1
    }
  },
  methods: {
    handleSubscribe() {
      if (!this.subscribeEmail) return
      // 这里可以接入真实订阅接口
      this.subscribed = true
      this.subscribeEmail = ''
      setTimeout(() => {
        // 3 秒后复位，方便重复演示
      }, 3000)
    }
  }
}
</script>

<style scoped>
/* ================================================================
   Blog Footer —— 深色主题 + 渐变光晕
   ================================================================ */

.blog-footer {
  position: relative;
  overflow: hidden;
  color: #c9d1d9;
  background:
    linear-gradient(180deg, #2c3e50 0%, #3d5381 40%, #29a0a0 100%);
  padding: 0 0 28px;
  margin-top: 80px;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC',
    'Microsoft YaHei', Roboto, Helvetica, Arial, sans-serif;
}

/* 顶部波浪 —— 与页面内容自然过渡 */
.footer-wave {
  position: relative;
  display: block;
  line-height: 0;
  color: #f8f9fa;
  margin-top: -1px;
}

.footer-wave svg {
  position: relative;
  display: block;
  width: 100%;
  height: 60px;
  transform: rotate(180deg);
}

/* 背景光晕装饰 */
.footer-glow {
  position: absolute;
  border-radius: 50%;
  pointer-events: none;
  filter: blur(80px);
  opacity: 0.35;
  z-index: 0;
}

.glow-left {
  left: -120px;
  top: 40px;
  width: 360px;
  height: 360px;
  background: radial-gradient(circle, #2563eb 0%, transparent 70%);
}

.glow-right {
  right: -100px;
  top: 180px;
  width: 320px;
  height: 320px;
  background: radial-gradient(circle, #f97316 0%, transparent 70%);
}

/* 细腻网格纹理 */
.footer-grid-bg {
  position: absolute;
  inset: 0;
  background-image:
    linear-gradient(rgba(255, 255, 255, 0.03) 1px, transparent 1px),
    linear-gradient(90deg, rgba(255, 255, 255, 0.03) 1px, transparent 1px);
  background-size: 48px 48px;
  pointer-events: none;
  z-index: 0;
  mask-image: linear-gradient(180deg, transparent 0%, #000 25%, #000 75%, transparent 100%);
  -webkit-mask-image: linear-gradient(180deg, transparent 0%, #000 25%, #000 75%, transparent 100%);
}

/* 容器 */
.container {
  position: relative;
  z-index: 1;
  max-width: 1200px;
  margin: 0 auto;
  padding: 60px 24px 0;
}

/* 主体布局 */
.footer-main {
  display: grid;
  grid-template-columns: 1.6fr 1fr 1fr 1.3fr;
  gap: 48px;
  padding-bottom: 48px;
}

/* ---------------- 品牌区 ---------------- */
.footer-brand {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.brand-logo {
  display: inline-flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  color: #fff;
  width: fit-content;
  transition: transform 0.3s ease;
}

.brand-logo:hover {
  transform: translateY(-1px);
}

.brand-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #3b82f6 0%, #6366f1 50%, #8b5cf6 100%);
  color: #fff;
  font-weight: 700;
  font-size: 18px;
  border-radius: 10px;
  box-shadow:
    0 4px 12px rgba(59, 130, 246, 0.3),
    inset 0 1px 0 rgba(255, 255, 255, 0.2);
}

.brand-text {
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.5px;
  background: linear-gradient(90deg, #fff 0%, #93c5fd 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.brand-desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.75;
  color: #94a3b8;
  max-width: 360px;
}

/* 运行数据区 */
.brand-stats {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 14px 18px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  backdrop-filter: blur(8px);
  width: fit-content;
  transition: all 0.3s ease;
}

.brand-stats:hover {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(59, 130, 246, 0.3);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.25);
}

.stat-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  min-width: 52px;
}

.stat-num {
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  font-variant-numeric: tabular-nums;
}

.stat-label {
  font-size: 11px;
  color: #64748b;
  letter-spacing: 0.5px;
}

.stat-divider {
  width: 1px;
  height: 28px;
  background: linear-gradient(180deg, transparent, rgba(255, 255, 255, 0.15), transparent);
}

/* 社交图标 */
.social-list {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.social-link {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  color: #cbd5e1;
  text-decoration: none;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  overflow: hidden;
}

.social-link::before {
  content: '';
  position: absolute;
  inset: 0;
  background: var(--hover-color, linear-gradient(135deg, #3b82f6, #6366f1));
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 0;
}

.social-link svg {
  position: relative;
  z-index: 1;
  transition: transform 0.3s ease;
}

.social-link:hover {
  color: #fff;
  border-color: transparent;
  transform: translateY(-3px);
  box-shadow: 0 8px 18px rgba(0, 0, 0, 0.3);
}

.social-link:hover::before {
  opacity: 1;
}

.social-link:hover svg {
  transform: scale(1.1);
}

/* 各社交专属配色 */
.social-github { --hover-color: linear-gradient(135deg, #333, #6e5494); }
.social-juejin { --hover-color: linear-gradient(135deg, #1e80ff, #007fff); }
.social-weibo  { --hover-color: linear-gradient(135deg, #e6162d, #ff6b6b); }
.social-wechat { --hover-color: linear-gradient(135deg, #07c160, #2ba977); }
.social-rss    { --hover-color: linear-gradient(135deg, #f97316, #ea580c); }

/* ---------------- 列通用样式 ---------------- */
.footer-col {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.col-title {
  position: relative;
  margin: 0;
  padding-left: 14px;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 0.5px;
}

.col-title-bar {
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 16px;
  border-radius: 3px;
  background: linear-gradient(180deg, #3b82f6 0%, #8b5cf6 100%);
  box-shadow: 0 0 8px rgba(59, 130, 246, 0.4);
}

.col-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.col-list li {
  margin: 0;
}

.col-list a {
  position: relative;
  display: inline-block;
  color: #94a3b8;
  text-decoration: none;
  font-size: 14px;
  padding-left: 0;
  transition: all 0.25s ease;
}

.col-list a::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 6px;
  border-radius: 3px;
  background: linear-gradient(90deg, #3b82f6, #8b5cf6);
  opacity: 0;
  transition: all 0.3s ease;
}

.col-list a:hover {
  color: #fff;
  padding-left: 14px;
}

.col-list a:hover::before {
  width: 6px;
  opacity: 1;
}

/* ---------------- 订阅区 ---------------- */
.footer-subscribe {
  gap: 16px;
}

.subscribe-desc {
  margin: 0;
  font-size: 13px;
  line-height: 1.7;
  color: #94a3b8;
}

.subscribe-form {
  display: flex;
  align-items: center;
  gap: 0;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 12px;
  padding: 4px;
  transition: all 0.3s ease;
}

.subscribe-form:focus-within {
  border-color: rgba(59, 130, 246, 0.5);
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.15);
  background: rgba(255, 255, 255, 0.06);
}

.subscribe-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  padding: 10px 12px;
  font-size: 13px;
  color: #fff;
  min-width: 0;
}

.subscribe-input::placeholder {
  color: #64748b;
}

.subscribe-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 9px 16px;
  background: linear-gradient(135deg, #3b82f6 0%, #6366f1 100%);
  color: #fff;
  border: none;
  border-radius: 9px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(59, 130, 246, 0.25);
}

.subscribe-btn:hover:not(:disabled) {
  transform: translateY(-1px);
  box-shadow: 0 6px 18px rgba(59, 130, 246, 0.4);
}

.subscribe-btn:active:not(:disabled) {
  transform: translateY(0);
}

.subscribe-btn:disabled {
  background: linear-gradient(135deg, #059669, #10b981);
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.25);
  cursor: default;
}

.subscribe-tip {
  margin: 0;
  font-size: 12px;
  color: #34d399;
  animation: fadeSlide 0.4s ease;
}

@keyframes fadeSlide {
  from {
    opacity: 0;
    transform: translateY(4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* 联系方式迷你区 */
.contact-mini {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px dashed rgba(255, 255, 255, 0.08);
}

.contact-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12.5px;
  color: #94a3b8;
}

.contact-item svg {
  color: #60a5fa;
  flex-shrink: 0;
}

/* ---------------- 分割线 ---------------- */
.footer-divider {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px 0 24px;
}

.footer-divider::before,
.footer-divider::after {
  content: '';
  flex: 1;
  height: 1px;
  background: linear-gradient(
    90deg,
    transparent 0%,
    rgba(255, 255, 255, 0.12) 50%,
    transparent 100%
  );
}

.divider-dot {
  width: 6px;
  height: 6px;
  margin: 0 16px;
  border-radius: 50%;
  background: linear-gradient(135deg, #3b82f6, #8b5cf6);
  box-shadow: 0 0 12px rgba(59, 130, 246, 0.6);
  flex-shrink: 0;
}

/* ---------------- 底部版权栏 ---------------- */
.footer-bottom {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 16px;
  padding: 0 4px;
}

.copyright p {
  margin: 0;
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.6;
}

.copyright-sub {
  margin-top: 4px !important;
  font-size: 12px !important;
  color: #64748b;
}

.text-link {
  color: #93c5fd;
  text-decoration: none;
  transition: color 0.2s ease;
}

.text-link:hover {
  color: #fff;
}

.power-heart {
  color: #ef4444;
  display: inline-block;
  animation: heartBeat 1.6s ease-in-out infinite;
}

@keyframes heartBeat {
  0%, 100% { transform: scale(1); }
  15% { transform: scale(1.2); }
  30% { transform: scale(1); }
  45% { transform: scale(1.15); }
}

.footer-nav ul {
  display: flex;
  align-items: center;
  list-style: none;
  margin: 0;
  padding: 0;
  gap: 4px;
}

.footer-nav li {
  display: flex;
  align-items: center;
}

.footer-nav li + li::before {
  content: '';
  width: 3px;
  height: 3px;
  margin: 0 10px;
  border-radius: 50%;
  background: #475569;
}

.footer-nav a {
  color: #94a3b8;
  text-decoration: none;
  font-size: 13px;
  transition: color 0.25s ease;
}

.footer-nav a:hover {
  color: #fff;
}

/* ================================================================
   响应式
   ================================================================ */

/* 992px —— 2 栏 */
@media (max-width: 992px) {
  .footer-main {
    grid-template-columns: 1fr 1fr;
    gap: 40px;
  }

  .footer-brand {
    grid-column: 1 / -1;
  }
}

/* 768px —— 1 栏 */
@media (max-width: 768px) {
  .blog-footer {
    margin-top: 60px;
    padding-bottom: 24px;
  }

  .footer-wave svg {
    height: 40px;
  }

  .container {
    padding: 40px 20px 0;
  }

  .footer-main {
    grid-template-columns: 1fr;
    gap: 36px;
    padding-bottom: 36px;
  }

  .footer-brand {
    grid-column: auto;
    gap: 16px;
  }

  .brand-desc {
    max-width: 100%;
  }

  .brand-stats {
    width: 100%;
    justify-content: space-around;
    padding: 12px 16px;
  }

  .footer-bottom {
    flex-direction: column;
    text-align: center;
    gap: 14px;
  }

  .footer-nav ul {
    justify-content: center;
    flex-wrap: wrap;
    gap: 8px 0;
  }

  .footer-nav li + li::before {
    margin: 0 8px;
  }
}

/* 480px —— 超小屏 */
@media (max-width: 480px) {
  .container {
    padding: 32px 16px 0;
  }

  .footer-main {
    gap: 28px;
  }

  .brand-text {
    font-size: 20px;
  }

  .brand-icon {
    width: 32px;
    height: 32px;
    font-size: 16px;
  }

  .subscribe-form {
    flex-wrap: wrap;
    gap: 8px;
    padding: 6px;
  }

  .subscribe-input {
    flex: 1 1 100%;
    min-width: 0;
  }

  .subscribe-btn {
    flex: 1 1 100%;
    padding: 10px 16px;
  }

  .stat-num {
    font-size: 16px;
  }

  .copyright-sub {
    font-size: 11px !important;
  }
}
</style>
